export const nationalities = [
  "Indian",
  "NRI (Non-Resident Indian)"
];
